import React, {useState, useEffect, useRef} from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Logo from '../../assets/images/tugo-logo-light.svg';
import styles from '../Layout.module.css';
import { BaseUrl } from '../config';
import payImg from '../../assets/images/payment-accept.png';

 function Footer () {

        const [height, setHeight] = useState(0);
        const [visible, setVisible] = useState(false);
        const [settingsList, setsettingsList] = useState([]);
        const heightRef = useRef();
        const [cookieshow, setcookieshow] = useState(true);
        const [cookieAccepted, setcookieAccepted] = useState([]);

        const getSize = () => {

        let newHeight = heightRef.current.clientHeight;
        setHeight(newHeight);
        };

        useEffect(() => {
            getSize();

        })

        useEffect(() => {
            window.addEventListener("resize", getSize);
            getSettings();

          const cookieValue = localStorage.getItem('cookie_accepted');
            if (cookieValue) {
              setcookieAccepted(cookieValue);
              setcookieshow(false);
              const div = document.querySelector('body');
              div.classList.remove('cookies-on');
           }

          }, []);

        document.body.style.setProperty('--padBottom', height+'px');

        var currentDate = new Date();

        function scrollTop(){

            window.scroll({
                 top: 0,
                 left: 0,
                 behavior: "smooth"
            });
        }

         const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            if (scrolled > 300){
              setVisible(true)
            } 
            else if (scrolled <= 300){
              setVisible(false)
            }
          };

         window.addEventListener('scroll', toggleVisible);


         function getSettings(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        

         let URL = BaseUrl + "settings";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data[0];
            if(responseData !==''){
                setsettingsList(responseData);
           }
           }).catch((err) => {
            console.log(err);
           });
         }



         function cookiePopClose(e){
            e.preventDefault();

            var cookieChecked = localStorage.getItem('cookie_accepted');

            if(cookieChecked == '' || cookieChecked === null || cookieChecked == 'null'){

                localStorage.setItem('cookie_accepted', 'Yes');

                setcookieAccepted('Yes');
                setcookieshow(false);

                const div = document.querySelector('body');
                 div.classList.remove('cookies-on');
            }

         }

         function showCookie(e) {
           e.preventDefault();
           setcookieshow(false);
           const div = document.querySelector('body');
           div.classList.remove('cookies-on');
         }

        return(
            <>
                <footer ref={heightRef}>
                    <div className="sm-container">
                    
                        <div className={styles.footerWrap}>
                            <div className={styles.footerLeft}>
                                <div className={styles.footLogo}>
                                    <Link to="/" className={styles.logo}>
                                        <img src={Logo} alt="Tugo" />
                                    </Link>
                                </div>
                                <div className={styles.footAdr}>
                                    <p>Tugo Towers,<br></br> 14 Somerville Court,<br></br> Adderbury,<br></br> OX17 3SN</p>
                                </div>
                                <div className={styles.footLinks}>
                                    <ul className={styles.footnav}>
                                        <li>
                                            <a href="/checkout/pizza">Pizza</a>
                                        </li>
                                        <li>
                                            <a href="/checkout/pasta-rice-noodle-sauces">Pasta, Rice & Noodle Sauces</a>
                                        </li>
                                        <li>
                                            <a href="/checkout/burrito">Burrito</a>
                                        </li>
                                        <li>
                                            <a href="/categories" >Products Info</a>
                                        </li>
                                        {localStorage.getItem('specialofferdisplay') === 'Yes' &&
                                        <li>
                                            <a href="/offerinfo" >Special Offer</a>
                                        </li>
                                        }
                                    </ul>
                                    <ul className={styles.footnav}>
                                        <li>
                                            <a target="_blank" href="https://www.tugo.co.uk/cookies" >Cookies</a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.tugo.co.uk/privacy-policy">Privacy Policy</a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.tugo.co.uk/terms-and-conditions">Terms & Conditions</a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://www.tugo.co.uk/contact">Contact Us</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={styles.footerRight}>
                                <span className={styles.link}>
                                <a href="tel: 01295 367351"><i className="fa fa-phone" aria-hidden="true"></i> 01295 367351</a>
                                </span>
                                <span className={styles.link}>
                                <a href="mailto: info@tugo.co.uk"><i className="fa fa-envelope" aria-hidden="true"></i> info@tugo.co.uk</a>
                                </span>
                                <div className={styles.fotPayOpt}>
                                    <p>We Accept</p>
                                    <img src={payImg} alt="Payment Option" className="payImg" />
                                </div>
                            </div>
                        </div>

                        <div className={styles.footerCopy}>
                            <div className={styles.CopyTxt}>

                            {settingsList !== '' ? <p> {settingsList.copyrightText} </p> :  <p>© Copyright {currentDate.getFullYear()} Tugo. All rights reserved.</p>}

                            </div>
                            <div className={styles.footSocial}>
                            {settingsList !== '' && Object.keys(settingsList).length > 0 && 
                                <ul>
                                    {settingsList.linkedinURL !==''&& 
                                    <li><a href={settingsList.linkedinURL !=='' ? settingsList.linkedinURL : ""} target="_blank"><i className="fa fa-linkedin"></i></a></li>
                                    }

                                    {settingsList.instagramURL !=='' && 
                                    <li><a href={settingsList.instagramURL !=='' ? settingsList.instagramURL : ""} target="_blank"><i className="fa fa-instagram"></i></a></li>
                                    }

                                    {settingsList.facebookURL !=='' &&
                                    <li><a href={settingsList.facebookURL !=='' ? settingsList.facebookURL : ""} target="_blank"><i className="fa fa-facebook"></i></a></li>
                                    }

                                    {settingsList.youtubeURL !=='' &&
                                    <li><a href={settingsList.youtubeURL !=='' ? settingsList.youtubeURL : ""} target="_blank"><i className="fa fa-youtube-play"></i></a></li>
                                    }

                                    {settingsList.twitterURL !=='' &&
                                    <li><a href={settingsList.twitterURL !=='' ? settingsList.twitterURL : ""}
                                        target="_blank"><i className="fa fa-twitter"></i></a></li>
                                    }
                                </ul>
                              }
                            </div>
                        </div>

                    </div>

                    {cookieAccepted !== 'Yes' && cookieshow === true && 
                    <div className="cookie-bar">
                        <a className="cookie-close" onClick={(e) => showCookie(e)}></a>
                        <p>By viewing our website, you agree to the use of <a href="https://www.tugo.co.uk/cookies" target="_blank">cookies</a>. 
                        <a className="button cookie-btn" onClick={(e) => cookiePopClose(e)}>Accept Cookies</a></p>
                    </div>
                    }


                     <div className= {visible ? "scrolltop show" : "scrolltop"} id="scrollbutton" onClick={scrollTop}>
                      <a className="disbl_href_action"><span>
                      <i className="fa fa-angle-double-up ars"></i>
                      <i className="fa fa-angle-up ars1"></i>
                      <i className="fa fa-angle-up ars2"></i></span>
                      </a>
                    </div>

                </footer>
            </>
        );

}
export default Footer;